export const StationsMixins = {
  data(){
    return{
      stations:[
        {stationId:1,name:'充电站全貌',image:"https://admin.casmrc.cn:9999/jeecg-boot/image/station/1527153139407958017/16628835191844670576980.jpg",path:'/stations'},
        {stationId:2,name:'电站指示牌',image:"https://admin.casmrc.cn:9999/jeecg-boot/image/station/1527153139407958017/16628835191840471801091.jpg",path:'/stations'},
        {stationId:3,name:'电站运营时',image:"https://admin.casmrc.cn:9999/jeecg-boot/image/station/1527153139407958017/16628835191841460798114.jpg",path:'/stations'},
      ],
      imageSrcList:[]
    }
  },
  mounted() {
    this.imageSrcList = this.stations.map(item=>item.image)
  },
  methods:{
    toStation(item){
      console.log(item)
      this.$router.push(item.path)
    }
  }
}
